import { ofType, StateObservable } from "redux-observable";
import { from, Observable as ActionsObservable, of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { ActionType } from "../../constants/redux";
import { RootState } from "../../reducer";
import { GET_NEWS, TOGGLE_ERROR_DIALOG, UPDATE_ERROR_MESSAGE } from "./type";
import { ajax, AjaxError } from "rxjs/ajax";
import { queryParam } from "../../utils/functions";
import { get } from "http";
import { NEWS_API } from "../../constants/routes";

export const Epic1 = (
  action$: ActionsObservable<ActionType>,
  rootState$: StateObservable<RootState>
) =>
  action$.pipe(
    ofType(TOGGLE_ERROR_DIALOG.name),
    mergeMap((action) => {
      const data = action.payload;
      return from(ajax({ url: "https://www.google.com", method: "GET" })).pipe(
        map((resposne: any) =>
          TOGGLE_ERROR_DIALOG.successAction(resposne, action)
        ),
        catchError((error: any) =>
          of(TOGGLE_ERROR_DIALOG.failureAction(error, action))
        )
      );
    })
  );

export const Epic2 = (
  action$: ActionsObservable<ActionType>,
  rootState$: StateObservable<RootState>
) =>
  action$.pipe(
    ofType(UPDATE_ERROR_MESSAGE.name),
    mergeMap((action) => {
      const data = action.payload;
      return from(ajax({ url: "https://www.google.com", method: "GET" })).pipe(
        map((resposne: any) =>
          UPDATE_ERROR_MESSAGE.successAction(resposne, action)
        ),
        catchError((error: any) =>
          of(UPDATE_ERROR_MESSAGE.failureAction(error, action))
        )
      );
    })
  );

export const NewsEpic = (
  action$: ActionsObservable<ActionType>,
  rootState$: StateObservable<RootState>
) =>
  action$.pipe(
    ofType(GET_NEWS.name),
    mergeMap((action) => {
      return from(
        ajax({
          url: "https://www.reddit.com/r/technology/hot.json",
          method: "GET",
          crossDomain: true,
          createXHR: () => new XMLHttpRequest(),
          headers: {
            Accept: "application/json",
          },
        })
      ).pipe(
        map((response: any) => GET_NEWS.successAction(response, action)),
        catchError((error: any) => of(GET_NEWS.failureAction(error, action)))
      );
    })
  );
